<template>
    <!-- 레이어 팝업 .pop_event_01 예약하기 시작 -->
    <div class="layerWrapper" v-bind:class="getStyle">
      <div class="cbox layerBox popWidS" style="left: 50%; top: 50%;">
        <div class="cart-popup__dialog">
          <div class="cart-popup__content height-auto">
            <div class="cart-popup__item-info" style="padding:0">
              <div class="os_noticeRes" data-btn-close="closeLayer">
                <div class="padS txtC" style="background-color:#fff;color:#000">

                  <!-- 예약확정 메세지 -->
                  <div v-show="isShowLayer(['RESERVED'])" class="padSM padBM" style="border:2px solid #000;border-radius:18px">
                    <div><img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_artistry_notm_s.png" alt="Artistry Skin Nutrition(로고)" style="max-width:129px;min-width:60px;width:35%"></div>
                    <div class="marTM"><img src="https://media.amway.co.kr/sys-master/images/h73/hd6/9319858700318/230411_ico_01.png" alt="" class="icoXS" style="max-width: 100px; width: 20%;"></div>
                    <p class="marTSM fntH6 fntL">
                      <strong>
                      예약이 확정되었습니다.
                      </strong>
                    </p>
                  </div>
                  <!-- ///예약확정 메세지 -->

                  <!-- 예약확인 메세지 -->
                  <div v-show="isShowLayer(['SELECTED'])" class="padSM padBM" style="border:2px solid #000;border-radius:18px">
                    <div><img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_artistry_notm_s.png" alt="Artistry Skin Nutrition(로고)" style="max-width:129px;min-width:60px;width:35%"></div>
                    <div class="marTM"><img src="https://media.amway.co.kr/sys-master/images/he0/hda/9319858896926/230411_ico_03.png" alt="" class="icoXS" style="max-width: 100px; width: 20%;"></div>
                    <p class="marTSM fntH6 fntL">
                      <strong>
                      예약 내역을 확인해주세요.
                      </strong>
                    </p>
                    <ul class="fntH6 light marTML padTM padBM" style="background-color: #f3f3f3;">
                      <li class="">
                        <b>ABC</b><br>
                        {{reserve.abc}}
                      </li>
                      <li class="marTSM">
                        <b>날짜</b><br>
                        {{reserve.day}}
                      </li>
                      <li class="marTSM">
                        <b>시간대</b><br>
                        {{reserve.time}}
                      </li>
                      <li class="marTSM">
                        <b>원하는 메이크업 룩</b><br>
                        {{reserve.style }}
                      </li>
                    </ul>
                  </div>
                  <!-- ///예약확인 메세지 -->

                  <!-- 예약취소 메세지 -->
                  <div v-show="isShowLayer(['CANCELLED'])" class="padSM padBM" style="border:2px solid #000;border-radius:18px">
                    <div><img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_artistry_notm_s.png" alt="Artistry Skin Nutrition(로고)" style="max-width:129px;min-width:60px;width:35%"></div>
                    <div class="marTM"><img src="https://media.amway.co.kr/sys-master/images/h78/hd7/9319858798622/230411_ico_02.png" alt="" class="icoXS" style="max-width: 100px; width: 20%;"></div>
                    <p class="marTSM fntH6 fntL" >
                      <strong>
                      예약이 취소되었습니다.
                      </strong>
                    </p>
                  </div>
                  <!-- ///예약취소 메세지 -->

                  <!-- 예약마감 메세지 -->
                  <div v-show="isShowLayer(['BEING_DAY', 'CLODE_RESERVE_DAY', 'CLOSE_CANCEL_DAY', 'CLOSE_CHECK_DAY'])" class="padSM padBM" style="border:2px solid #000;border-radius:18px">
                    <div><img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_artistry_notm_s.png" alt="Artistry Skin Nutrition(로고)" style="max-width:129px;min-width:60px;width:35%"></div>
                    <div class="marTM"><img src="https://media.amway.co.kr/sys-master/images/hf2/hdd/9319858962462/230411_ico_04.png" alt="" class="icoXS" style="max-width: 100px; width: 20%;"></div>
                    <p class="marTSM fntH6 fntL" v-html="reserve.message">
                    </p>
                  </div>
                  <!-- ///예약마감 메세지 -->

                  <!-- 이미 확정된 예약 -->
                  <div v-show="isShowLayer(['RESERVED_ME','RESERVED_OTHER'])" class="padSM padBM" style="border:2px solid #000;border-radius:18px">
                    <div><img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_artistry_notm_s.png" alt="Artistry Skin Nutrition(로고)" style="max-width:129px;min-width:60px;width:35%"></div>
                    <div class="marTM"><img src="imges/Ico_05.png" alt="" class="icoXS" style="max-width: 100px; width: 20%;"></div>
                    <p class="marTSM fntH6 fntL" v-html="reserve.message">
                    </p>
                  </div>
                  <!-- /// 이미 확정된 예약 -->

                  <!-- 예약 내역 없음  -->
                  <div v-show="isShowLayer(['NOT_RESERVED'])" class="padSM padBM" style="border:2px solid #000;border-radius:18px">
                    <div><img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_artistry_notm_s.png" alt="Artistry Skin Nutrition(로고)" style="max-width:129px;min-width:60px;width:35%"></div>
                    <div class="marTM"><img src="imges/Ico_05.png" alt="" class="icoXS" style="max-width: 100px; width: 20%;"></div>
                    <p class="marTSM fntH6 fntL" v-html="reserve.message"></p>
                  </div>
                  <!-- ///예약 내역 없음  -->

                  <!-- 로그인 않헀을때 -->
                  <div v-show="isShowLayer(['INVALID_ABO_NO', 'INVALID_ABO_NAME'])" class="padSM padBM" style="border:2px solid #000;border-radius:18px">
                    <div><img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_artistry_notm_s.png" alt="Artistry Skin Nutrition(로고)" style="max-width:129px;min-width:60px;width:35%"></div>
                    <div class="marTM"><img src="imges/Ico_06.png" alt="" class="icoXS" style="max-width: 100px; width: 20%;"></div>
                    <p class="marTSM fntH6 fntL" v-html="reserve.message"></p>
                  </div>
                  <!-- ///로그인 않헀을때 -->

                  <!-- Custom message layer -->
                  <div v-show="isShowLayer(['INVALID_ABC', 'INVALID_DATE', 'INVALID_TIME', 'INVALID_STYLE',  'OTHER_ERROR'])" class="padSM padBM" style="border:2px solid #000;border-radius:18px">
                    <div><img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_artistry_notm_s.png" alt="Artistry Skin Nutrition(로고)" style="max-width:129px;min-width:60px;width:35%"></div>
                    <div class="marTM"><img src="imges/Ico_06.png" alt="" class="icoXS" style="max-width: 100px; width: 20%;"></div>
                    <p class="marTSM fntH6 fntL" v-html="reserve.message"></p>
                  </div>
                  <!-- // Custom message layer -->

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>

export default {
  name: "artistryMakeoverLayerPopup",
  props: ['layers', 'reserve'],
  methods: {
    isShowLayer: function (arg) {
      return arg.indexOf(this.layers.selectItem) > -1
    }
  },
  computed : {
    getStyle () { 
      return this.layers.mode[this.layers.selectItem]
    },
    isMode() { 
      return this.layers.selectItem || 'NOT_RESERVED'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/artistry/makeover/components/layerPopup.vue